const Pagination = ({
  // totalItems,
  // itemsPerPage = 10
  totalPages,
  currentPage,
  setCurrentPage
}) => {

  // const totalPages = Math.ceil(totalItems / itemsPerPage);
  console.log("Total Pages in Pagination:", totalPages);
  if (totalPages <= 1) return null;

  return (
    <div className="d-flex justify-content-center gap-2 mt-4">
      {[...Array(totalPages)].map((_, i) => {
        const page = i + 1;

        return (
          <button
            key={page}
            onClick={() => setCurrentPage(page)} //onPageChange
            className={`btn ${
              page === currentPage
                ? "btn-primary"
                : "btn-outline-primary"
            }`}
          >
            {page}
          </button>
        );
      })}
    </div>
  );
};

export default Pagination;
